import { getUrlParamsFetch, urlBackend } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { UseFetchEnabledParams } from '@/shared/interfaces';
import {
  IUbicacionProducto,
  IUbicacionProductoPaginaRes,
  IUbicacionProductoParams,
} from '@/shared/interfaces/erp/inventario';
import { useQuery } from '@tanstack/react-query';

const { get } = erpApi();

/**
 * OBTENER UBICACION PRODUCTOS
 *
 */

export enum UbicacionProductoQueryKeysEnum {
  UBICACION_PRODUCTO = 'ubicacion-producto',
  UBICACIONES_PRODUCTO = 'ubicaciones-producto',
}

export const useFetchUbicacionProductosEnabled = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<IUbicacionProductoParams>) => {
  return useQuery({
    queryKey: [
      UbicacionProductoQueryKeysEnum.UBICACIONES_PRODUCTO,
      ...Object.values(params || {}),
    ],
    queryFn: async () => {
      return await getUbicacionProductos(params);
    },
    refetchOnWindowFocus: false,
    enabled,
  });
};

export const getUbicacionProductos = async (
  params?: IUbicacionProductoParams
) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<IUbicacionProductoPaginaRes>(
    `${urlBackend}api/v1/ubicacion-producto/?${queryParams}`,
    true
  );
  return resp;
};

export const useFetchUbicacionProductosByProductCode = ({
  enabled = true,
  codes,
  params,
}: {
  enabled: boolean;
  codes: string[];
  params?: IUbicacionProductoParams;
}) => {
  return useQuery({
    queryKey: [UbicacionProductoQueryKeysEnum.UBICACION_PRODUCTO],
    queryFn: async () => {
      return await getUbicacionProductosByProductCode(codes, params);
    },
    enabled,
  });
};

export const getUbicacionProductosByProductCode = async (
  codes: string[],
  params?: IUbicacionProductoParams
) => {
  // /?productos=MATE,PROD,PROD2
  const urlCodes = codes.map(code => `${code}`).join(',');
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<IUbicacionProductoPaginaRes>(
    `${urlBackend}api/v1/ubicacion-producto/?productos=${urlCodes}&${queryParams}`,
    true
  );

  return resp;
};

/**
 * OBTENER PRODUCTOS DE LA BODEGA POR ID_UBICACION
 *
 * PARAMETRO:
 * > id_ubicacion_producto
 *
 */

export const useFetchUbicacionProductosByUbicacion = ({
  enabled = true,
  id_ubicacion_producto, //id_ubicacion_producto
}: {
  enabled: boolean;
  id_ubicacion_producto: number;
}) => {
  return useQuery({
    queryKey: [UbicacionProductoQueryKeysEnum.UBICACIONES_PRODUCTO],
    queryFn: async () => {
      return await getUbicacionProductosByUbicacion(id_ubicacion_producto);
    },
    enabled,
  });
};

export const getUbicacionProductosByUbicacion = async (
  id_ubicacion_producto: number
) => {
  const resp = await get<IUbicacionProducto>(
    `${urlBackend}api/v1/ubicacion-producto/${id_ubicacion_producto}/`,
    true
  );
  return resp;
};

//
export const getUbicacionProductoByCodigoIdUbicacion = async (
  params?: IUbicacionProductoParams
) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<IUbicacionProductoPaginaRes>(
    `${urlBackend}api/v1/ubicacion-producto/?${queryParams}`,
    true
  );

  return resp.data.data[0];
};


///* ubucacion producto simple

export const useFetchUbicacionProductoSimple = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<IUbicacionProductoParams>) => {
  return useQuery({
    queryKey: [
      'ubicacion-producto-simple',
      ...Object.values(params || {}),
    ],
    queryFn: async () => {
      return await getUbicacionProductoSimple(params);
    },
    refetchOnWindowFocus: false,
    enabled,
  });
};

export const getUbicacionProductoSimple = async (
  params?: IUbicacionProductoParams
) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<IUbicacionProductoPaginaRes>(
    `${urlBackend}api/v1/ubicacion-producto-simple/?${queryParams}`,
    true
  );
  return resp;
};